import { render } from "./rwgl.vue?vue&type=template&id=10459e38&scoped=true"
import script from "./rwgl.vue?vue&type=script&lang=js"
export * from "./rwgl.vue?vue&type=script&lang=js"

import "./rwgl.vue?vue&type=style&index=0&id=10459e38&scoped=true&lang=css"

import exportComponent from "D:\\智诚大数据\\禁种铲毒\\禁种铲毒平台\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10459e38"]])

export default __exports__